<template>
	<div class="form-mdfpwd">

		<el-form ref="form" :model="form" :rules="rules" label-width="" :disabled="isLook" @submit.native.prevent>
			<div class="pwdhead">
				<span class="pwdtitle">修改分类</span>
				<div class="closediv" @click="close"><span class="close"></span></div>
			</div>
			<el-form-item label="名称：" prop="name">
				<el-input placeholder="请填写名称" v-model="form.name" @keyup.enter.native="submitForm('form')" clearable> </el-input>
			</el-form-item>
			<!-- <button type="button" @click="submitForm('form')" class="ely-button"><span>确定</span></button> -->
      <el-button type="primary" @click="submitForm('form')" class="ely-button">确定</el-button>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'mdfpwd',
		data() {
			var validatePass = (rule, value, callback) => {
				if(!value) {
					callback(new Error('请填写名称'));
				} else {
					callback();
				}
			};

			return {
				form: {
					id: '',
					name: '',
				},
				rules: {
					name: [{
						required: true,
						validator: validatePass,
						trigger: 'change'
					}],
				}
			}
		},
		computed: {
			isLook() {
				return this.$store.state.isLook;
			},
		},
		methods: {
			binding(ObjectData) {
				this.form.id = parseInt(ObjectData.id);
				this.form.name = ObjectData.name;
			},
			submitForm(formName) {
				if(this.isLook)return;
				this.$refs[formName].validate(valid => {
					if(valid) {
						//如果通过验证 to do...
						//console.log(this.form.name)
						//this.common.permission(this);
						var self = this;
						this.post('/Dict/update', {
							id: this.form.id,
							name: this.form.name,
							type: 4,
						}).then((res) => {
							if(res.success == true) {
								this.$message({
							          showClose: true,
							          message: '修改成功',
							          type: 'success'
							        });
								this.form.name = '';
								//更新分类
								this.$parent.TypeListUpdata();
								//隐藏
								this.$parent.MdfClassify();
								//清楚校验结果
								this.$refs.form.resetFields();
							}
						})
					}
				})
			},
			close() {
				this.$parent.MdfClassify();
			}
		}
	}
</script>

<style scoped>
	.el-form>>>.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before, 
	.el-form>>>.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
		position: relative !important;
	    top: 3px !important;
	    left: 0 !important;
	}
	.form-mdfpwd {
		width: 100vw;
		height: 100vh;
		display: none;
		/*background: rgba(0, 0, 0, .4);*/
		position: absolute;
		top: -91px;
		bottom: 0;
		left: -250px;
		right: 0;
		z-index: 1000;
		margin: auto;
		opacity: 0;
	    transition: .2s;
	}
	
	.el-form {
		display: block;
		width: 470px;
		height: 240px;
		position: absolute;
		margin: auto;
		left: 0;
		right: 0;
		bottom: 0;
		top: -50px;
	    transition: .2s;
		background-color: #fff;
		border-radius: 1px;
	}
	
	.pwdhead {
		width: 100%;
		height: 53px;
		border-bottom: 1px solid #efefef;
	}
	
	.pwdhead .pwdtitle {
		float: left;
		color: #2F3A4E;
		font-size: 17px;
		margin-left: 30px;
		margin-top: 14px;
		cursor: context-menu;
	}
	
	.pwdhead .closediv {
		float: right;
		position: relative;
		margin-right: 25px;
		margin-top: 12px;
	    width: 27px;
    	height: 27px;
		cursor: pointer;
	}
	
	.pwdhead .close {
		float: right;
		position: relative;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
		display: inline-block;
		top: 5px;
		right: 15px;
	}
	
	.pwdhead .close:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 0.1em;
		height: 1.3em;
		background: #333;
		-webkit-transform: rotate(270deg);
		-moz-transform: rotate(270deg);
		-o-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg);
	}
	
	.el-form-item {
		margin: 0;
	    padding-left: 13px;
	    padding-top: 40px;
	    position: relative;
	    width: calc(100% - 13px);
	    height: calc(100% - 94px);
	}
	
	.el-form-item>>>.el-form-item__label {
		float: left;
		width: 105px;
		color: #2c3e50;
	}
	
	.el-form-item>>>.el-form-item__content {
		/*float: left;*/
	    width: 289px;
	    position: absolute;
	    top: 39px;
	    right: 0;
	    left: 40px;
	    margin: auto;
	}
	
	.el-form-item>>>.el-input__inner {
		padding: 0 !important;
		margin: 0 !important;
		color: #2F3030 !important;
		background: #fff !important;
		text-indent: 20px !important;
		border: 1px solid rgba(222, 222, 222, 1);
		border-radius: 0 !important;
	}
	
	.el-form>>>.ely-button {
		background-color: #5087E4;
		color: #fff;
		width: 86px;
		letter-spacing: 1px;
		margin-top: 18px;
		font-size: 13px;
		cursor: pointer;
		border: 0;
		border-radius: 5px;
		/* height: 34px; */
		/* line-height: 33px; */
		position: absolute;
		left: 0;
		right: 0;
		bottom: 33px;
		margin: auto;
		margin-top: 23px;
	}
	.TJCloud .el-form>>>.ely-button{
	  line-height: 11px;
	}
	.el-form>>>.el-select {
		width: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/components/SetUp/material/MdfClassify.vue